export enum ModalSize {
  small = 'small',
  large = 'large',
  fitContent = 'fitContent',
}

export const DefaultModalSize = ModalSize.small;
